import { c as _c } from "react/compiler-runtime";
import { X } from "lucide-react";
interface DismissButtonProps {
  onClick: (e: React.MouseEvent) => void;
  label: string;
}
export function DismissButton(t0) {
  const $ = _c(4);
  const {
    onClick,
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <X className="h-3.5 w-3.5" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label || $[2] !== onClick) {
    t2 = <button onClick={onClick} className="absolute -top-2 -right-2 h-6 w-6 rounded-[9999px] bg-white text-zinc-500 shadow-md flex items-center justify-center hover:text-zinc-800 hover:scale-110 transition-all" aria-label={label}>{t1}</button>;
    $[1] = label;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}